import { render, staticRenderFns } from "./base-tree-selector.vue?vue&type=template&id=6aa0b594&scoped=true"
import script from "./base-tree-selector.vue?vue&type=script&lang=js"
export * from "./base-tree-selector.vue?vue&type=script&lang=js"
import style0 from "./base-tree-selector.vue?vue&type=style&index=0&id=6aa0b594&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0b594",
  null
  
)

export default component.exports